/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InputBeginWebAuthnRegistrationRequest
 */
export interface InputBeginWebAuthnRegistrationRequest {
    /**
     * Optional name for the credential
     * @type {string}
     * @memberof InputBeginWebAuthnRegistrationRequest
     */
    name?: string;
}

/**
 * Check if a given object implements the InputBeginWebAuthnRegistrationRequest interface.
 */
export function instanceOfInputBeginWebAuthnRegistrationRequest(value: object): boolean {
    return true;
}

export function InputBeginWebAuthnRegistrationRequestFromJSON(json: any): InputBeginWebAuthnRegistrationRequest {
    return InputBeginWebAuthnRegistrationRequestFromJSONTyped(json, false);
}

export function InputBeginWebAuthnRegistrationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): InputBeginWebAuthnRegistrationRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
    };
}

export function InputBeginWebAuthnRegistrationRequestToJSON(value?: InputBeginWebAuthnRegistrationRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
    };
}

